import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Category } from '../common/category';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CategoryResponse } from '../common/category-response';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  private adminApiUrl: string = `${environment.apiUrl}/admin/categories`;
  private publicApiUrl: string = `${environment.apiUrl}/categories`;

  constructor(private http: HttpClient) { }

  getPublicCategoryList(page: number = 0, size: number = 10, name: string = ''): Observable<CategoryResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    if (name) {
      params = params.set('name', name);
    }
    return this.http.get<CategoryResponse>(this.publicApiUrl, { params: params });
  }

  getCategoryList(page: number = 0, size: number = 10, name: string = ''): Observable<CategoryResponse> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    if (name) {
      params = params.set('name', name);
    }
    return this.http.get<CategoryResponse>(this.adminApiUrl, { params: params });
  }

  getCategoryById(id: number): Observable<Category> {
    return this.http.get<Category>(`${this.adminApiUrl}/${id}`);
  }

  createCategory(category: Category): Observable<Category> {
    return this.http.post<Category>(this.adminApiUrl, category);
  }

  updateCategory(id: number, category: Category): Observable<Category> {
    return this.http.put<Category>(`${this.adminApiUrl}/${id}`, category);
  }

  deleteCategoryById(id: number): Observable<any> {
    return this.http.delete(`${this.adminApiUrl}/${id}`);
  }
}
